import type { FC, PropsWithChildren } from "react";

import { getLoaderOptions } from "@locators/components/shared/store-locator.config";

import { useConfig } from "@jti/app-context/useConfig";
import { useLocale } from "@jti/app-context/useLocale";
import { GoogleAPIProvider } from "@jti/fe-clients";

interface StoreLocatorProviderWrapperProps {
  componentLevelLanguage?: string;
}

export const StoreLocatorProviderWrapper: FC<PropsWithChildren<StoreLocatorProviderWrapperProps>> = ({
  children,
  componentLevelLanguage,
}) => {
  const { locationServiceMapProvider, GOOGLE_MAPS_API, ISO_COUNTRY_CODE } = useConfig();
  const locale = useLocale();

  const effectiveLanguage = componentLevelLanguage?.trim() || locale;

  if (locationServiceMapProvider === "google") {
    return (
      <GoogleAPIProvider apiKey={GOOGLE_MAPS_API} options={getLoaderOptions(ISO_COUNTRY_CODE, effectiveLanguage)}>
        {children}
      </GoogleAPIProvider>
    );
  }

  return children;
};
